import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { IBaseModel } from "../../shared/interfaces/shared/IBase";
import { requests } from "../../utils/api/api.service";
import { BEACONS_URL } from "../../utils/api/endpoints";
import { IBeacon } from "../../shared/interfaces/beacon/IBeacon";

export const BeaconService = {
  getAll: (params: IPagination): Promise<IBaseModel<IBeacon[]>> =>
    requests.get(BEACONS_URL, params),
  getSingle: (id: number): Promise<{ data: IBeacon }> =>
    requests.get(`${BEACONS_URL}/${id}`),
  create: (payload: IBeacon): Promise<IBeacon> =>
    requests.post(BEACONS_URL, payload),
  update: (payload: IBeacon, id?: number): Promise<IBeacon> =>
    requests.put(`${BEACONS_URL}/${id}`, payload),
  delete: (id: number): Promise<void> =>
    requests.delete(`${BEACONS_URL}/${id}`),
};
